import { gql } from "apollo-boost"

export const checkIpDevice = gql`
  mutation checkIpDevice(
    $ip: String!,
    $city: String!,
    $region: String!,
    $os: String!,
    $browser: String!,
    $device: String!,
    $email: String!,
    $uid: String!
  ){
    checkIpDevice(
        ip: $ip,
        city: $city,
        region: $region,
        os:  $os,
        browser:  $browser,
        device: $device,
        email: $email,
        uid: $uid
    )
  }
`